import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/api";
import { CalendarDays, ArrowRight } from "lucide-react";

const imgSrc = (u) => (!u ? "" : u.startsWith("http") ? u : `${API.replace(/\/api$/, "")}${u}`);
const todayStr = () => new Date().toISOString().slice(0, 10);
const fmtShort = (d) => {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(y, m - 1, day).toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

export const UpcomingStrip = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/telegram/events`).then(({ data }) => {
      const t = todayStr();
      const up = (data.events || []).filter((e) => (e.date || "") >= t)
        .sort((a, b) => (a.date || "").localeCompare(b.date || "")).slice(0, 3);
      setItems(up);
    }).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="w-full" data-testid="home-upcoming-strip">
      <div className="mb-4 flex items-center justify-center gap-2">
        <CalendarDays className="h-4 w-4 text-gold-deep" />
        <p className="kicker text-ink-muted">Upcoming with Casey</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        {items.map((ev) => (
          <Link key={ev.id} to="/telegram" data-testid={`home-event-${ev.id}`}
            className="group flex items-center gap-3 rounded-xl bg-ivory-50 p-3 text-left ring-1 ring-ivory-400/60 transition hover:ring-gold/40">
            {ev.flyer_url && <img src={imgSrc(ev.flyer_url)} alt={ev.title} className="h-16 w-12 flex-none rounded object-cover ring-1 ring-ivory-400/60" />}
            <span className="min-w-0">
              <span className="block truncate font-display text-sm text-ink">{ev.title}</span>
              <span className="block text-xs text-ink-muted">{fmtShort(ev.date)}{ev.start_time ? ` · ${ev.start_time}` : ""}</span>
            </span>
          </Link>
        ))}
      </div>
      <div className="mt-4 text-center">
        <Link to="/telegram" data-testid="home-telegram-link" className="inline-flex items-center gap-1.5 font-display text-sm text-gold-deep transition hover:gap-2.5">
          See all events <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};
